const BaseView = require('components-framework/view/base.view');
const withRenderedMain = require('components-framework/view/with_rendered_main');
const trackingUtils = require('od-modules/utils/tracking.utils');

const MY_AREA_CATEGORY = 'my_area_account';

const toggleDialog = (open) => function() {
    this.$el.toggleClass('open opened', open);
};

const openDialog = toggleDialog(true);
const closeDialog = toggleDialog(false);

module.exports = withRenderedMain(BaseView.extend({
    events: {
        'tap .cancel_member_account_close': 'onClose',
    },

    onClose() {
        trackingUtils.trackEventWithCategory(MY_AREA_CATEGORY, 'account_details', 'cancel_account_block_close_acc:prime');
        closeDialog.call(this);
    },

    open() {
        trackingUtils.trackEventWithCategory(MY_AREA_CATEGORY, 'account_details', 'cancel_account_block_acc:prime');
        openDialog.call(this);
    },
}));
